import { atom } from 'jotai'
import type { RefObject } from 'react'

export const productListFiltersMobileItemOpen = atom<string | boolean | undefined>(undefined)
export const isEventConditionsDrawerOpenAtom = atom(false)
export const productListFiltersMenuRefAtom = atom<RefObject<HTMLDivElement | null> | null>(null)

/**
 * Atom that indicates whether the product list skeletons are displayed.
 */
export const isProductListPageLoadingAtom = atom(false)
